import React, { useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import { Card, CardContent } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { useMaterialUIController, setSideBarVisibility } from "context";

import PublicDocsNavbar from "./components/PublicDocsNavbar";
import Footer from "./components/PublicDocsFooter";

// Account Opening
import AONav from "../docs/account-opening/components/account-opening-nav";
import AODocs from "../docs/account-opening/components/account-opening-doc";
// Funding
import FundingNav from "../docs/funding/components/funding-nav";
import FundingDocs from "../docs/funding/components/funding-doc";
// Trading (latest: v2.5.3)
import TrdNav from "../docs/trading-two-five-three/components/trading-nav";
import TrdDocs from "../docs/trading-two-five-three/components/trading-doc";
// Trading v2.5.1
import TrdNavV251 from "../docs/trading-two-five-one/components/trading-nav";
import TrdDocsV251 from "../docs/trading-two-five-one/components/trading-doc";
// Trading v2.5
import TrdNavV25 from "../docs/trading-two-five/components/trading-nav";
import TrdDocsV25 from "../docs/trading-two-five/components/trading-doc";
// Trading v2.4
import TrdNavV24 from "../docs/trading-two-four/components/trading-nav";
import TrdDocsV24 from "../docs/trading-two-four/components/trading-doc";
// Trading v2.3
import TrdNavV23 from "../docs/trading-two-three/components/trading-nav";
import TrdDocsV23 from "../docs/trading-two-three/components/trading-doc";
// Trading v2.2.4
import TrdNavV224 from "../docs/trading/components/trading-nav";
import TrdDocsV224 from "../docs/trading/components/trading-doc";
// Fix (latest: v3.5)
import FixNav from "../docs/fix-three-five/components/fix-nav";
import FixDocs from "../docs/fix-three-five/components/fix-doc";
// Fix v3.2
import FixNavV32 from "../docs/fix/components/fix-nav";
import FixDocsV32 from "../docs/fix/components/fix-doc";
// Journal
// gFlux
import GFluxNav from "../docs/corporate-actions-api/components/journal-nav";
import GFluxDocs from "../docs/corporate-actions-api/components/journal-doc";
// gRisk
import GRiskNav from "../docs/gRisk/components/journal-nav";
import GRiskDocs from "../docs/gRisk/components/journal-doc";

import "../docs/docs.css";
import "./landing.css";
import "./public-docs-landing.css";
import "bootstrap/dist/css/bootstrap.min.css";

const docsMap = {
  "account-opening": { Nav: AONav, Doc: AODocs },
  funding: { Nav: FundingNav, Doc: FundingDocs },
  trading: { Nav: TrdNav, Doc: TrdDocs },
  "trading-v251": { Nav: TrdNavV251, Doc: TrdDocsV251 },
  "trading-v25": { Nav: TrdNavV25, Doc: TrdDocsV25 },
  "trading-v24": { Nav: TrdNavV24, Doc: TrdDocsV24 },
  "trading-v23": { Nav: TrdNavV23, Doc: TrdDocsV23 },
  "trading-v224": { Nav: TrdNavV224, Doc: TrdDocsV224 },
  fix: { Nav: FixNav, Doc: FixDocs },
  "fix-v32": { Nav: FixNavV32, Doc: FixDocsV32 },
  gflux: { Nav: GFluxNav, Doc: GFluxDocs },
  grisk: { Nav: GRiskNav, Doc: GRiskDocs },
  "risk-margin-api": { Nav: GRiskNav, Doc: GRiskDocs },
};

const apiLabels = {
  "account-opening": "Account Opening API",
  funding: "Funding API",
  trading: "Trading API",
  "trading-v251": "Trading API",
  "trading-v25": "Trading API",
  "trading-v24": "Trading API",
  "trading-v23": "Trading API",
  "trading-v224": "Trading API",
  fix: "Fix Specification",
  "fix-v32": "Fix Specification",
  "corporate-actions-api": "Corporate Actions API",
  gflux: "Corporate Actions API",
  "risk-margin-api": "Risk & Margin API",
  grisk: "Risk & Margin API",
};

const apiVersions = {
  "account-opening": "v4.9",
  funding: "v1.0",
  trading: "v2.5.3",
  "trading-v251": "v2.5.1",
  "trading-v25": "v2.5",
  "trading-v24": "v2.4",
  "trading-v23": "v2.3",
  "trading-v224": "v2.2.4",
  fix: "v3.5",
  "fix-v32": "v3.2",
  "corporate-actions-api": "v1.0",
  gflux: "v1.0",
  "risk-margin-api": "v1.0",
  grisk: "v1.0",
};

const apiVersionOptions = {
  "account-opening": [{ label: "v4.9", route: "/" }],
  funding: [{ label: "v1.0", route: "/docs/funding" }],
  trading: [
    { label: "v2.5.3", route: "/docs/trading" },
    { label: "v2.5.1", route: "/docs/trading/v2.5.1" },
    { label: "v2.5",   route: "/docs/trading/v2.5" },
    { label: "v2.4",   route: "/docs/trading/v2.4" },
    { label: "v2.3",   route: "/docs/trading/v2.3" },
    { label: "v2.2.4", route: "/docs/trading/v2.2.4" },
  ],
  "trading-v251": [
    { label: "v2.5.3", route: "/docs/trading" },
    { label: "v2.5.1", route: "/docs/trading/v2.5.1" },
    { label: "v2.5",   route: "/docs/trading/v2.5" },
    { label: "v2.4",   route: "/docs/trading/v2.4" },
    { label: "v2.3",   route: "/docs/trading/v2.3" },
    { label: "v2.2.4", route: "/docs/trading/v2.2.4" },
  ],
  "trading-v25": [
    { label: "v2.5.3", route: "/docs/trading" },
    { label: "v2.5.1", route: "/docs/trading/v2.5.1" },
    { label: "v2.5",   route: "/docs/trading/v2.5" },
    { label: "v2.4",   route: "/docs/trading/v2.4" },
    { label: "v2.3",   route: "/docs/trading/v2.3" },
    { label: "v2.2.4", route: "/docs/trading/v2.2.4" },
  ],
  "trading-v24": [
    { label: "v2.5.3", route: "/docs/trading" },
    { label: "v2.5.1", route: "/docs/trading/v2.5.1" },
    { label: "v2.5",   route: "/docs/trading/v2.5" },
    { label: "v2.4",   route: "/docs/trading/v2.4" },
    { label: "v2.3",   route: "/docs/trading/v2.3" },
    { label: "v2.2.4", route: "/docs/trading/v2.2.4" },
  ],
  "trading-v23": [
    { label: "v2.5.3", route: "/docs/trading" },
    { label: "v2.5.1", route: "/docs/trading/v2.5.1" },
    { label: "v2.5",   route: "/docs/trading/v2.5" },
    { label: "v2.4",   route: "/docs/trading/v2.4" },
    { label: "v2.3",   route: "/docs/trading/v2.3" },
    { label: "v2.2.4", route: "/docs/trading/v2.2.4" },
  ],
  "trading-v224": [
    { label: "v2.5.3", route: "/docs/trading" },
    { label: "v2.5.1", route: "/docs/trading/v2.5.1" },
    { label: "v2.5",   route: "/docs/trading/v2.5" },
    { label: "v2.4",   route: "/docs/trading/v2.4" },
    { label: "v2.3",   route: "/docs/trading/v2.3" },
    { label: "v2.2.4", route: "/docs/trading/v2.2.4" },
  ],
  fix: [
    { label: "v3.5", route: "/docs/fix" },
    { label: "v3.2", route: "/docs/fix/v3.2" },
  ],
  "fix-v32": [
    { label: "v3.5", route: "/docs/fix" },
    { label: "v3.2", route: "/docs/fix/v3.2" },
  ],
  "corporate-actions-api": [{ label: "v1.0", route: "/docs/corporate-actions-api" }],
  "risk-margin-api": [{ label: "v1.0", route: "/docs/risk-margin-api" }],
  grisk: [{ label: "v1.0", route: "/docs/risk-margin-api" }],
};

function PublicDocsLanding({ api = "account-opening" }) {
  const [, dispatch] = useMaterialUIController();
  const [search, setSearch] = useState("");
  const scrollRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    setSideBarVisibility(dispatch, false);
  }, []);

  const getData = (data) => setSearch(data);

  const { Nav, Doc } = docsMap[api] || docsMap["account-opening"];

  return (
    <div
      style={{
        background: "#f7f6f9",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <PublicDocsNavbar />
      <div style={{ flex: 1, minHeight: 0, display: "flex" }}>
        <Card
          style={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            borderRadius: 0,
            boxShadow: "none",
            border: 0,
            background: "#F1F2F5",
          }}
          className="onscroll pdl-card"
          ref={scrollRef}
        >
          <CardContent style={{ padding: 0 }}>
            <div className="pdl-container">
            <Grid container spacing={2} style={{ alignItems: "stretch" }}>
              <Grid item md={2.5} xs={12} style={{ display: "flex", flexDirection: "column"}}>
                <Card
                  className="sticky-nav"
                  style={{
                    borderRadius: 0,
                    boxShadow: "none",
                    background: "#fff",
                    flex: 1,
                  }}
                >
                  <CardContent style={{ paddingTop: 0 }}>
                    <Nav
                      searchedData={getData}
                      titleNode={
                        <div className="pdl-nav-title">
                          <span className="pdl-nav-title__name">{apiLabels[api] || "Documentation"}</span>
                          {apiVersionOptions[api]?.length > 1 ? (
                            <select
                              className="pdl-nav-title__version-select"
                              value={apiVersions[api]}
                              onChange={(e) => {
                                const opt = apiVersionOptions[api].find((o) => o.label === e.target.value);
                                if (opt) navigate(opt.route);
                              }}
                            >
                              {apiVersionOptions[api].map((opt) => (
                                <option key={opt.label} value={opt.label}>{opt.label}</option>
                              ))}
                            </select>
                          ) : (
                            <span className="pdl-nav-title__version">{apiVersions[api] || "v1"}</span>
                          )}
                        </div>
                      }
                    />
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={9.5} xs={12} className="scroll-inside" style={{ background: "#F2F3F6" }}>
                <Grid container spacing={0} py={0}>
                  <Doc scrollRef={scrollRef} search={search} />
                </Grid>
              </Grid>
            </Grid>
            </div>
            <Footer />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

export default PublicDocsLanding;

